<template>
  <van-popup
    v-model:show="show"
    round
    closeable
    :style="{
      width: '90%',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5'
    }"
  >
    <div class="postermerge-bg">
      <div class="content">
        <img id="poster" :src="poster" alt="合成图片" @touchstart="onTouchstart(poster)" @touchend="onTouchend()">
      </div>
      <div class="title">长按海报，保存到手机或转发好友</div>
      <!-- <van-button
        v-if="showBtn"
        round
        block
        type="default"
        icon-position="center"
        color="linear-gradient(to right,#f48260, #e53531)"
        url="http://www.zsnews.cn/app/mobile.html"
        >下载中山+新闻客户端</van-button
      > -->
    </div>
  </van-popup>
</template>

<script>
import { computed, ref } from "vue"
import { useStore } from "vuex"
import { Popup } from "vant"
import { Button } from "vant"
import "@/plugins/bridge.js"

export default {
  name: "Statement",
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  setup() {
    const store = useStore()
    const showBtn = ref(false)
    // const isAndroid = ref(false)
    const userAgentString = navigator.userAgent.toLowerCase()
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true
    }

    let loop = null;
    const onTouchstart = (image) => {
      if (userAgentString.indexOf('zsrbapp') >= 0) {
        console.log(image);
        clearTimeout(loop);
        loop = setTimeout(() => {
            window.ZsrbApp.call("sharePic", {
              title: "中山日报10000期，给你道万福，快来生成你的专属头条",
              img:  image.replace("data:image/png;base64,",""),
              desc: "中山日报 出品",
              url: "https://zsrbactivity.zsnews.cn/vue/poster/"
            })
        },700);
      }
    }

    const onTouchend = () => {
      clearTimeout(loop);
    }


    // if (userAgentString.indexOf("Android") > -1) {
    //   isAndroid = true
    // }
    return {
      poster: computed(() => store.state.poster), 
      showBtn,
      onTouchstart,
      onTouchend,
      // isAndroid
    }
  },
  computed: {
    show: {
      get() {
        return this.$store.state.showPosterMerge
      },
      set(value) {
        this.$store.commit("updateShowPosterMerge", value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.postermerge-bg {
  width: 100%;
  // background: #eaeaea;
  // background: url('../assets/img/background.jpg') no-repeat;
  // background-color: #6a1f15;
  // background-size: 100%;
  padding: 50px 20px;
  .title {
    text-align: center;
    font-size: 4vw;
    margin-top: 12px;
    font-weight: 500;
    color: #848484;
  }
  .content {
    text-align: justify;
  }
  #poster {
    width: 100%;
    // -webkit-touch-callout: none;
  }
}
</style>
